import React, { useState, useEffect } from "react";
import { Field, useFormikContext } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { updatePostData } from "../../../../Redux/Slice/createPostSlice";
import {
  BUSINESS_FORM_ACTION_ROW_BETWEEN_CLASS,
} from "../../shared/businessLayoutSpec";
import {
  AdminHeaderAction,
  AdminLinkAction,
  AdminDetailFieldLabel,
  AdminFormFieldError,
  adminWizardInputClasses,
  adminWizardTextareaClasses,
} from "../../../AdminDashboard/shared/adminUx";

const PostDetails = ({ setStep, setFieldValue, values, handlePost }) => {
  const dispatch = useDispatch();
  const postData = useSelector((state) => state.createPost);
  const [isUpdating, setIsUpdating] = useState(false);
  const { errors: formikErrors } = useFormikContext();

  const handleNextClick = () => {
    if (values.postTitle && values.description) {
      dispatch(
        updatePostData({
          postTitle: values.postTitle,
          description: values.description,
        })
      );
      setIsUpdating(true);
    }
  };

  useEffect(() => {
    if (isUpdating && postData.postTitle) {
      handlePost();
      setIsUpdating(false);
      setStep(4);
    }
  }, [isUpdating, postData.postTitle]);

  const isFormValid = () =>
    values.postTitle?.trim() &&
    values.description?.trim() &&
    !formikErrors.postTitle &&
    !formikErrors.description;

  return (
    <>
      <div className="w-full">
        <Field name="postTitle">
          {({ field, form }) => {
            const hasError = Boolean(form.touched.postTitle && form.errors.postTitle);
            return (
              <div className="space-y-1 w-full min-w-0">
                <AdminDetailFieldLabel htmlFor="postTitle">
                  Title <span className="text-alertred">*</span>
                </AdminDetailFieldLabel>
                <input
                  {...field}
                  id="postTitle"
                  type="text"
                  placeholder="Enter post title"
                  value={values.postTitle}
                  onChange={(e) => setFieldValue("postTitle", e.target.value)}
                  className={adminWizardInputClasses(hasError)}
                />
                {hasError ? (
                  <AdminFormFieldError>{form.errors.postTitle}</AdminFormFieldError>
                ) : null}
              </div>
            );
          }}
        </Field>

        <div className="mt-5">
          <Field name="description">
            {({ field, form }) => {
              const hasError = Boolean(form.touched.description && form.errors.description);
              return (
                <div className="space-y-1 w-full min-w-0">
                  <AdminDetailFieldLabel htmlFor="description">
                    Description <span className="text-alertred">*</span>
                  </AdminDetailFieldLabel>
                  <textarea
                    {...field}
                    id="description"
                    placeholder="Enter description of your service"
                    value={values.description}
                    onChange={(e) => setFieldValue("description", e.target.value)}
                    className={adminWizardTextareaClasses(hasError)}
                  />
                  {hasError ? (
                    <AdminFormFieldError>{form.errors.description}</AdminFormFieldError>
                  ) : null}
                </div>
              );
            }}
          </Field>
        </div>
      </div>

      <div className={BUSINESS_FORM_ACTION_ROW_BETWEEN_CLASS}>
        <AdminLinkAction type="button" onClick={() => setStep(2)}>
          Back
        </AdminLinkAction>
        <AdminHeaderAction type="button" onClick={handleNextClick} disabled={!isFormValid()}>
          Next
        </AdminHeaderAction>
      </div>
    </>
  );
};

export default PostDetails;
